import React, { Component } from 'react';
import {
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Addresses.css';

class ListAddresses extends Component {
    constructor(props) {
        super(props);
        this.createdTS = parseInt(String(props.row.created).substr(5, 2)) + '/' + parseInt(String(props.row.created).substr(8, 2)) + '/' + String(props.row.created).substr(2, 2);
        this.updatedTS = parseInt(String(props.row.timestamp).substr(5, 2)) + '/' + parseInt(String(props.row.timestamp).substr(8, 2)) + '/' + String(props.row.timestamp).substr(2, 2);
    }

    displayType = (displayType) => {
        if (!displayType) return '';
        const notesCategoriesList = this.props.notesCategories.filter(item => item.type === 'Address Type').pop()?.list;
        const notesCategoriesIndex = notesCategoriesList?.findIndex(item => item.ID === parseInt(displayType));
        return (notesCategoriesIndex >= -1) ? notesCategoriesList[notesCategoriesIndex].longDescription : '';
    }

    parsePhone = (val) => {
        if (val.length !== 10 || isNaN(val)) return val;
        return `(${val.substring(0, 3)}) ${val.substring(3, 6)}-${val.substring(6, 10)}`;
    }

    render() {
        return (
            <Row key={this.props.row.linkedID}
                className="notesFormTypeRow pointer"
                onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}>
                <Col sm={9} className="notesFormTypeComments text-left"><>
                    {this.props.row.children['Street 1'] != null &&
                        <Row className="notesFormCommentRow">
                            <Col md={12} className="border-bottom pb-1 pt-1">
                                <div>{this.props.row.children['Street 1']}
                                    {this.props.row.children['Address Type'] &&
                                        <span className="commentTag"> {this.displayType(this.props.row.children['Address Type'])}</span>}</div>
                            </Col>
                        </Row>}
                    {this.props.row.children['Street 2'] != null &&
                        <Row className="notesFormCommentRow">
                            <Col md={12} className="border-bottom pb-1 pt-1">
                                <div>{this.props.row.children['Street 2']}</div>
                            </Col>
                        </Row>}
                    {(this.props.row.children['City'] || this.props.row.children['State'] || this.props.row.children['Zip'])
                        && <Row className="notesFormCommentRow">
                            <Col md={12} className="border-bottom pb-1 pt-1">
                                <div>{this.props.row.children['City'] && `${this.props.row.children['City']}, `}
                                    {this.props.row.children['State'] || ''}&nbsp;
                                    {this.props.row.children['Zip'] || ''} 
                                </div>
                            </Col>
                        </Row>}
                    {!this.props.row.active && <Row className="notesFormCommentRow">
                        <Col sm={5} className="border-bottom pb-1 pt-1">
                            <Label>Active</Label>
                        </Col>
                        <Col sm={7} className="border-bottom pb-1 pt-1">
                            No
                        </Col>
                    </Row>}
                </>
                </Col>
                <Col sm={3} className="notesFormTypeControls text-right">
                    <div className="noteCreatedTimestamp" >
                        {this.createdTS}
                    </div>
                    {this.createdTS !== this.updatedTS ?
                        <div className="noteUpdatedTimestamp"
                            title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                            {this.updatedTS}
                        </div> : <></>}
                    <div className="noteCreatedTimestamp"
                        title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                        {this.props.row.user.firstName + ' ' + this.props.row.user.lastName}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ListAddresses;
